import { $persons } from '~/src/game';

export const forEveryPerson = (callback: (person: Person) => void) => {
  Object.values($persons).map((person) => !person.diedAt && callback(person));
};
